<template>
    <v-footer padless absolute="absolute">
        <v-col
                class="text-center"
                cols="12"
        >
            <v-btn text>
                <a href="https://evidenzdervernunft.solutions/impressum/" class="routerLink">IMPRESSUM</a>
            </v-btn>
          <v-btn text>
            <a href="https://evidenzdervernunft.solutions/datenschutzerklaerung/" class="routerLink">DATENSCHUTZERKLÄRUNG</a>
          </v-btn>
        </v-col>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .routerLink {
        text-decoration: none;
      color: gray;
    }

    .routerLink:hover {
        text-decoration: none;
    }

</style>
